/** Platform-wide master groups — always visible regardless of enabled service modules */
export const COMMON_MASTER_GROUP_KEYS = new Set([
  'geo',
  'locale',
  'operations',
  'payments',
]);

/** Hub → master group keys (mirrors backend scopes) */
export const HUB_SERVICE_MASTER_GROUPS: Record<string, string[]> = {
  transport: ['transport_masters', 'transport_hubs'],
  delivery: ['delivery_masters'],
  on_demand: ['on_demand_masters'],
  video_consultation: ['video_consultation_masters'],
  booking: ['events_masters'],
};

export function isHubMasterGroup(groupKey: string, hub?: string): boolean {
  if (!hub) return false;
  return (HUB_SERVICE_MASTER_GROUPS[hub] || []).includes(groupKey);
}
